import React from "react";
import Layout from "../../layouts/Layout";
import DesktopDatePickerSC from "../../components/DesktopDatePickerSC";
import TextFieldSC from "../../components/TextFieldSC";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import actions from "../../redux/actions";
import _ from "lodash"
import apiService from "../../utils/api.service";
import helper from "../../utils/helper";
import HistoryPoint from "./HistoryPoint"
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/th';

class PointHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectDate: moment(),
      pointHistory: []
    };
    this.goBack = this.goBack.bind(this);
    this.totalPoint = this.totalPoint.bind(this);
    this.datetoMonth = this.datetoMonth.bind(this);
  }
  componentDidMount() {
    this.LoadHistoryPoint()
  }

  async LoadHistoryPoint() {
    try {
      const { selectDate } = this.state
      const _selectDate = selectDate.$d || selectDate
      console.log('LoadHistoryPoint selectDate >>', selectDate.$d)
      const M = moment(_selectDate).format('M') 
      const YYYY = moment(_selectDate).format('YYYY') 
      const payload = { memberId: this.props?.user?.lineId?.memberId, month: M, year: YYYY }
      const header = helper.GEN.toValueHeader(this.props)
      const { resData } = await apiService.Collect.SearchRewardHistories(payload, header)
      if (resData.resultCode === "20000") {
        const data = _.cloneDeep(resData.data)
        console.log('data >>', data)
        this.setState({ pointHistory: data })
      }
    }
    catch(e){
      console.log('API ERR', e)
    }
  }

  goBack() {
    this.props.navigate(`/collect-point`);
  }

  totalPoint (pointList = []) {
    let total = 0
    for (const pl of pointList) {
      if ([1,2,3].includes(pl.type)) {
        total = total + pl.amount
      }
      else if ([4,5].includes(pl.type)) {
        total = total * pl.bonus
      }
    }
    return helper.FN.toNumberWithCommas(total)
  }

  datetoMonth(selectDate) {
    const _selectDate = selectDate.$d || selectDate
    console.log('LoadHistoryPoint selectDate >>', selectDate.$d)
    const M = moment(_selectDate).format('M') 
    const YYYY = moment(_selectDate).format('YYYY') 
    return `${helper.CONFIG.MONTH[M]} ${YYYY}` 
  }

  render() {
    const { selectDate, pointHistory } = this.state;
    return (
      <Layout>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'th'}>
          <div className="main-header" style={{ padding: "25px 15px 10px" }}>
            <svg
              onClick={() => {
                this.goBack();
              }}
              width="11"
              height="18"
              viewBox="0 0 11 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.374541 8.04405L7.61252 0.396439C8.11279 -0.132146 8.92174 -0.132146 9.41669 0.396439L10.6195 1.66729C11.1197 2.19588 11.1197 3.05061 10.6195 3.57357L5.49435 9L10.6248 14.4208C11.1251 14.9494 11.1251 15.8041 10.6248 16.3271L9.42201 17.6036C8.92174 18.1321 8.11279 18.1321 7.61784 17.6036L0.379863 9.95595C-0.125731 9.42737 -0.125731 8.57263 0.374541 8.04405Z"
                fill="white"
              />
            </svg>

            <div style={{ fontSize: "24px", marginLeft: "20px", textAlign: "center", width: "100%" }}>
              ประวัติการรับแต้มสะสมบุญ
            </div>
          </div>

          <div
            className="container-renew2"
            style={{ background: "white", margin: "15px" }}
          >
            <div
              className="select-month"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "20px",
              }}
            >
              <div style={{ width: "150px" }}>
                <DesktopDatePickerSC
                  views={['month', 'year']}
                  minDate={'2022-11-01'}
                  maxDate={moment().add(10,'year').format('YYYY-MM-DD')}
                  value={selectDate}
                  onChange={(newValue) => {
                    console.log('newValue >>', newValue)
                    this.setState({ selectDate: newValue }, ()=> this.LoadHistoryPoint());
                  }}
                  renderInput={(params) => {
                    return <TextFieldSC {...params}  variant="standard" fullWidth helperText={null} />
                  }}
                />
              </div>
            </div>
            <main className="history-container">
              <ul className="history-box">
                { 
                  pointHistory.map((item, index) => {
                    return <HistoryPoint key={index} historyPointData={item}/>
                  })
                }
              </ul>
            </main>
            <hr className="point"/>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "0 20px",
                alignItems: "center",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                <span style={{ color: "#2685CA", fontSize: "12px" }}>
                  รวมแต้มทั้งหมด
                </span>
                <span style={{ color: "#8F8F8F", fontSize: "8px" }}>
                  เดือน{ this.datetoMonth(selectDate) }
                </span>
              </div>
              <div className="total-point">
                <div className="total-point-text">{ this.totalPoint(pointHistory) }</div>
                <div className="total-point-text" style={{ fontSize: "12px" }}>บาท</div>
              </div>
            </div>
            <hr className="point"/>
          </div>
        </LocalizationProvider>
      </Layout>
    );
  }
}

function PointHistoryRoute(props) {
  let navigate = useNavigate();
  return <PointHistory navigate={navigate} {...props} />;
}

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};
export default connect(mapStateToProps, actions)(PointHistoryRoute);
